var $2e7c5f88d5a513cf$exports = {};
$2e7c5f88d5a513cf$exports = {
    "loading": `Carregando...`,
    "loadingMore": `Carregando mais...`
};


export {$2e7c5f88d5a513cf$exports as default};
//# sourceMappingURL=pt-BR.mjs.map
